import React, { useEffect, useRef, useState } from 'react';

// Число, що плавно «докручується» до target (ease-out cubic, як баланс на
// головній). paused — поки над головною відкрито екран (напр. переказ):
// лишаємо старе значення й анімуємо, коли головну знову видно. Відлік часу
// — з першого кадру, тож якщо PWA була у фоні (кадри не малюються),
// анімацію все одно побачать, а не одразу кінцеве число.
export default function useAnimatedNumber(target, paused = false, duration = 700) {
  const [display, setDisplay] = useState(target);
  const displayRef = useRef(target); // те, що зараз на екрані — навіть посеред анімації
  const frameRef = useRef(null);

  useEffect(() => {
    if (paused) return undefined;
    const from = displayRef.current;
    if (from === target) return undefined;

    let start = null;
    function tick(now) {
      if (start === null) start = now;
      const t = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - t, 3);
      const current = from + (target - from) * eased;
      displayRef.current = current;
      setDisplay(current);
      if (t < 1) frameRef.current = requestAnimationFrame(tick);
    }
    frameRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frameRef.current);
  }, [target, paused, duration]);

  return display;
}

// Для списків (баланси додаткових карток), де хук у циклі не викличеш
export function AnimatedNumber({ value, paused, format }) {
  return <>{format(useAnimatedNumber(value, paused))}</>;
}
